// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na[data-v-22708564] {\n    text-decoration: underline;\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
